import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhatIncludes } from '../components/WhatIncludes';
import { Benefits } from '../components/Benefits';
import { Offer } from '../components/Offer';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel on page load
  useMetaPixel();
  return <div className="w-full min-h-screen bg-white" data-id="element-131">
      <Navigation data-id="element-132" />
      <Hero data-id="element-133" />
      <WhatIncludes data-id="element-134" />
      <Benefits data-id="element-135" />
      <Offer data-id="element-136" />
      <Testimonials data-id="element-137" />
      <FinalCTA data-id="element-138" />
      <Footer data-id="element-139" />
    </div>;
}